import axiosInstance from '@/lib/axios';

export async function readUserApi() {

    const response = await axiosInstance.get('/users/me');


    return response.data; // Axios automatically parses JSON

}









export async function recoveryAccount({ email, selectedQuestions = [], answers = {} }) {
    if (!email || typeof email !== 'string') {
        throw new Error('Invalid email provided');
    }

    if (!Array.isArray(selectedQuestions) || selectedQuestions.length !== 5) {
        throw new Error('Exactly 5 security questions must be selected');
    }

    const security_questions = selectedQuestions.map((questionId) => ({
        question_id: questionId,
        answer: answers[questionId] || "",
    }));

    try {
        const response = await axiosInstance.post('/users/users_security_questions/recover', {
            email,
            security_questions,
        });

        return response.data; // { access_token, token_type }
    } catch (error) {
        const errData = error.response?.data;

        throw new Error(
            `Failed to recover account: ${errData?.detail || JSON.stringify(errData) || error.message}`
        );
    }
}





export async function updatePasswordApi({ newPassword, confirmPassword }) {
    if (newPassword !== confirmPassword) {
        throw new Error('New passwords do not match!');
    }

    const token = localStorage.getItem('authToken');
    const tokenType = localStorage.getItem('tokenType');

    if (!token || !tokenType) {
        throw new Error('You are not authorized.');
    }

    try {
        const response = await axiosInstance.patch(
            '/users/me/recover',
            {
                new_password: newPassword,
                confirm_new_password: confirmPassword,
            },
            {
                headers: {
                    Authorization: `${tokenType} ${token}`,
                },
            }
        );

        return response.data;
    } catch (err) {
        const message =
            err.response?.data?.detail ||
            err.response?.data?.message ||
            err.message ||
            'Password change failed';
        throw new Error(message);
    }
}